import * as Types from '../../../generated/index'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
const defaultOptions = {} as const
export type MarkAllNotificationsReadMutationVariables = Types.Exact<{ [key: string]: never }>

export type MarkAllNotificationsReadMutation = {
  markAllNotificationsRead?: { success: boolean; errors: Array<string> } | null
}

export const MarkAllNotificationsReadDocument = gql`
  mutation markAllNotificationsRead {
    markAllNotificationsRead {
      success
      errors
    }
  }
`
export type MarkAllNotificationsReadMutationFn = Apollo.MutationFunction<
  MarkAllNotificationsReadMutation,
  MarkAllNotificationsReadMutationVariables
>

/**
 * __useMarkAllNotificationsReadMutation__
 *
 * To run a mutation, you first call `useMarkAllNotificationsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllNotificationsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllNotificationsReadMutation, { data, loading, error }] = useMarkAllNotificationsReadMutation({
 *   variables: {
 *   },
 * });
 */
export function useMarkAllNotificationsReadMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkAllNotificationsReadMutation,
    MarkAllNotificationsReadMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    MarkAllNotificationsReadMutation,
    MarkAllNotificationsReadMutationVariables
  >(MarkAllNotificationsReadDocument, options)
}
export type MarkAllNotificationsReadMutationHookResult = ReturnType<
  typeof useMarkAllNotificationsReadMutation
>
export type MarkAllNotificationsReadMutationResult =
  Apollo.MutationResult<MarkAllNotificationsReadMutation>
export type MarkAllNotificationsReadMutationOptions = Apollo.BaseMutationOptions<
  MarkAllNotificationsReadMutation,
  MarkAllNotificationsReadMutationVariables
>
